import { render, staticRenderFns } from "./page_home.vue?vue&type=template&id=7066d0a0&scoped=true"
import script from "./page_home.vue?vue&type=script&lang=js"
export * from "./page_home.vue?vue&type=script&lang=js"
import style0 from "./page_home.vue?vue&type=style&index=0&id=7066d0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7066d0a0",
  null
  
)

export default component.exports